import React from "react";
import { NavLink } from "react-router-dom";
import { Phone, LayoutDashboard, ListMinus, Users, Settings, PhoneCall, Headphones } from "lucide-react";
import { MobileNumberSwitcher } from "@/components/mobile/MobileNumberSwitcher";
import { Dialer } from "@/components/Dialer";
import { useAuth } from "@/context/AuthContext";

const ADMIN_LINKS = [
  { to: "/", label: "Tableau de bord", icon: LayoutDashboard, testid: "tabletnav-dashboard", end: true },
  { to: "/appels", label: "Appels récents", icon: ListMinus, testid: "tabletnav-calls" },
  { to: "/contacts", label: "Contacts", icon: Users, testid: "tabletnav-contacts" },
  { to: "/parametres", label: "Paramètres", icon: Settings, testid: "tabletnav-settings" },
];

const AGENT_LINKS = [
  { to: "/appels", label: "Appels récents", icon: ListMinus, testid: "tabletnav-calls" },
  { to: "/contacts", label: "Contacts", icon: Users, testid: "tabletnav-contacts" },
  { to: "/mon-poste", label: "Mon poste", icon: Headphones, testid: "tabletnav-my-station" },
];

// Superviseurs: same as agents + the dashboard (no Réglages).
const SUPERVISEUR_LINKS = [
  { to: "/", label: "Tableau de bord", icon: LayoutDashboard, testid: "tabletnav-dashboard", end: true },
  ...AGENT_LINKS,
];

// Icon-only collapsed sidebar for tablets (768–1023px).
export const TabletSidebar = () => {
  const { user, isAdmin } = useAuth();
  const links = isAdmin ? ADMIN_LINKS : user?.role === "superviseur" ? SUPERVISEUR_LINKS : AGENT_LINKS;
  return (
    <aside
      data-testid="tablet-sidebar"
      className="hidden md:flex lg:hidden w-20 fixed h-screen top-0 left-0 border-r border-slate-200 bg-white flex-col items-center z-20 py-4"
    >
      <div className="h-10 w-10 rounded-xl bg-emerald-600 flex items-center justify-center mb-4">
        <PhoneCall className="h-5 w-5 text-white" strokeWidth={2.4} />
      </div>

      <MobileNumberSwitcher
        trigger={
          <button
            data-testid="tablet-switcher-trigger"
            title="Changer de ligne"
            className="h-11 w-11 rounded-xl border border-slate-200 flex items-center justify-center text-slate-600 hover:bg-slate-50 mb-2"
          >
            <Phone className="h-5 w-5" />
          </button>
        }
      />

      <div className="mb-4">
        <Dialer
          trigger={
            <button
              data-testid="tablet-dialer-btn"
              title="Appeler"
              className="h-11 w-11 rounded-xl bg-emerald-600 text-white flex items-center justify-center hover:bg-emerald-700"
            >
              <Phone className="h-5 w-5" strokeWidth={2.4} />
            </button>
          }
        />
      </div>

      <nav className="flex flex-col gap-1.5">
        {links.map(({ to, label, icon: Icon, testid, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            data-testid={testid}
            title={label}
            className={({ isActive }) =>
              `h-11 w-11 rounded-xl flex items-center justify-center transition-colors ${
                isActive ? "bg-emerald-50 text-emerald-700" : "text-slate-500 hover:bg-slate-50"
              }`
            }
          >
            <Icon className="h-5 w-5" strokeWidth={2} />
          </NavLink>
        ))}
      </nav>
    </aside>
  );
};
